import factory from '../requestFactory';

export default ({data}) => {
    return factory()
        .get(`/patient/diagnostic-files/check-file-list`, {
            params: {
                data
            }
        })
};
